module.exports = __webpack_public_path__ + "media/components/footer/static/weather__white-1530ebda7f5aa2ee45c7e7c2ad5c6697.svg";